import api from "./api";

class FileApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async add(formData): Promise<any> {
    const result = await this.getHttp().post<any>("/files", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return result.data;
  }
}
export default new FileApi();
